import React from 'react';
import { Anchor, X } from 'lucide-react';
import { Button } from '@/components/molecules/buttons/button';
import { Label } from '@/components/atoms/texts/label';
import { useTranslation } from 'react-i18next';

const ChatHeader = ({ unreadCount, candidateName, onClose, isAnchored, onToggleAnchor }) => {
    const [t] = useTranslation('global');
    const initials = String(candidateName || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('') || '??';

    return (
        <div className="flex items-center justify-between gap-2.5 bg-primary px-4 py-3">
            <div className="flex min-w-0 items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-secondary text-xs font-bold text-primary" aria-hidden="true">
                    <Label className="text-xs font-bold text-primary">{initials}</Label>
                </span>

                <div className="min-w-0 flex items-start flex-col leading-none gap-1">
                    <Label className="m-0 truncate " color="white" >
                        {candidateName || t('management.onboarding.chat.title')}
                    </Label>
                    <Label className="mt-0.5 inline-flex rounded-full  bg-[#FFFFFF20] px-2.5 py-0.5 " fontWeight={unreadCount > 0 ? 'bold' : 'normal'} color={unreadCount > 0 ? 'secondary' : 'white'} size="small">
                        {t('management.onboarding.chat.unreadCount', { count: unreadCount })}
                    </Label>
                </div>
            </div>

            <div className="flex items-center gap-1.5">
                {onToggleAnchor && (
                    <Button
                        style="ghost"
                        sizePadding="small"
                        showText={false}
                        showToolTip
                        text={isAnchored ? 'management.onboarding.chat.switchToFloating' : 'management.onboarding.chat.switchToAnchored'}
                        showLeftIcon
                        leftIcon={<Anchor className="h-4 w-4" />}
                        className={` rounded-sm  ${isAnchored ? 'text-secondary' : 'text-grey '}`}
                        onClick={onToggleAnchor}
                        aria-label={isAnchored ? t('management.onboarding.chat.switchToFloating') : t('management.onboarding.chat.switchToAnchored')}
                    />
                )}

                {onClose && (
                    <Button
                        style="ghost"
                        sizePadding="small"
                        showText={false}
                        showToolTip
                        text="global.actions.close"
                        showLeftIcon
                        leftIcon={<X className="h-4 w-4" />}
                        className="rounded-sm  text-grey  hover:text-white"
                        onClick={onClose}
                        aria-label={t('global.actions.close')}
                    />
                )}
            </div>
        </div>
    );
};

export default ChatHeader;
